import { getBaseMetaTitle } from '@/environments'

const NewsDetail = () => import('./Main')

const route = {
  path: '/news/:id',
  name: 'news-detail',
  meta: {
    title: `News - ${getBaseMetaTitle}`
  },
  component: NewsDetail
}

export default route
